
import { ScenarioModel } from '../../Models/scenario-model';
import { Utilities } from 'src/app/utilities';

export class ScenarioMock {

  private static models: ScenarioModel[];
  private static  idCounter = 0;

  public static initMocks(){
    ScenarioMock.models = [];
    ScenarioMock.models.push({id:"rettsbxyyn",sId:++this.idCounter,name:"Login into the application",scenariosteps:["ebetbeetttbt","wvwverbt4b4tb","tcyyn6n6y56nu"] , _type: "scenario"});
    ScenarioMock.models.push({id:"fwgnbwghwbhwgkgw",sId:++this.idCounter, name:"Cheking the Case manager portal",scenariosteps:[], _type: "scenario"});

  }

  public static findByObjectId(id: string):ScenarioModel{
    let m = ScenarioMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id) return m[i];
    }
    return null;
  }

  public static findById(id:number):ScenarioModel{
    let m = ScenarioMock.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].sId) return m[i];
    }
    return null;
  }

  public static getItems():ScenarioModel[]{
    return ScenarioMock.models;
  }

  public static addNew(model:ScenarioModel){
    model.id = Utilities.makeid(10);
    model.sId = ++this.idCounter;
    ScenarioMock.models.push(model);
  }

  public static deleteModel(model: ScenarioModel){
    let m = ScenarioMock.models;
    for(let i = 0; i< m.length; i++){
      if(model.id == m[i].id) {
        ScenarioMock.models.splice(i,1);
      }

    }
  }

}
